// extracted by mini-css-extract-plugin
export default {"wrapper":"Lca-z","boldPrefix":"Mca-z","link":"Nca-z","message":"Oca-z","image":"Pca-z"};